import React, { useState, useEffect } from "react";
import styles from "../styles/styles";
import CarCard from "../components/CarCard/CarCard.js";
import { useNavigate } from "react-router-dom";
import "./TrainDashboard.css";
import LegendClass from "./TrainDashboard/Legend";
import TrainListClass from "./TrainDashboard/TrainList";
import { parseTrainData, parseCarData } from "../util/telemetryParser.js";
import { normalizeTelemetry } from "../util/normalizeTelemetry";
import { toDisplayTable } from "../util/telemetryParser";
import { PARAMETER_MAP } from "../util/PARAMETER_MAP.js";
import ParamAutocomplete from "../components/ParamAutocomplete/ParamAutocomplete.js";
import { formatMetric } from "../util/formatValue";
import { getConfig } from '../config/appConfig';
import SmartChart from "../components/SmartChart/SmartChart";
import Modal from "../components/Modal/Modal";
import { api } from "../services/apiService.js";
import TimeRangeSelector from "../components/TimeRangeSelector/TimeRangeSelector.js";
import MetricWidget from "../components/MetricWidget/MetricWidget";
import { Gauge, GaugeContainer, GaugeReferenceArc, GaugeValueArc, useGaugeState } from "@mui/x-charts";
import { usePermissao } from "../app/hooks/UsePermissao.js";
import SemPermissao from "../components/SemPermissao/SemPermissao.js";
import TrainView from "./TrainView.jsx";
import CarView from "./CarView.jsx";
import { Box, Paper, Typography } from "@mui/material";
import FiltrosTrens from "../components/FiltrosTrens/FiltrosTrens";
import { useAuth } from '../contexts/AuthContext';
import UserEmailDisplay from "../components/UserEmailDisplay/UserEmailDisplay.js";
import { useMinhaLinhaOperador } from "../app/hooks/useMinhaLinhaOperador";
import { useLocalStorage } from "../app/hooks/useLocalStorage";
function SimpleLoadingModal({ text = "Carregando..." }) {
    return (
        <div className="loading-overlay">
            <div className="loading-card">
                ⏳ {text}
            </div>
        </div>
    );
}

function Velocimetro() {
    const { valueAngle, outerRadius, cx, cy, value, valueMax } = useGaugeState();

    if (valueAngle === null) {
        return null;
    }

    const target = {
        x: cx + outerRadius * Math.sin(valueAngle),
        y: cy - outerRadius * Math.cos(valueAngle),
    };

    return (
        <g>
            <circle cx={cx} cy={cy} r={5} fill="red" />
            <path
                d={`M ${cx} ${cy} L ${target.x} ${target.y}`}
                stroke="red"
                strokeWidth={3}
            />

            <text
                x={cx}
                y={cy + 30}
                textAnchor="middle"
                fill="#66fcf1"
                fontSize="20"
                fontWeight="600"
            >
                {value.toFixed(0)} km/h
            </text>
        </g>
    );
}


function TrainDashboard() {
    const fetchingTrainRef = React.useRef(false);
    const { userInfo } = useAuth();
    const { numeroLinha: numeroLinhaOperador, idLinha: idLinhaOperador } = useMinhaLinhaOperador(userInfo);
    const [timeTick, setTimeTick] = useState(Date.now());
    const TIME_WINDOW_MS = 2 * 60 * 60 * 1000; // 2 horas
    const navigate = useNavigate();
    const [selectedParam, setSelectedParam] = useState(null);
    const [paramSearch, setParamSearch] = useState("");
    const [trainSelected, setTrainSelected] = useState(null);
    const [trainInfo, setTrainInfo] = useState(null);
    const [cars, setCars] = useState([]);
    const [carSelected, setCarSelected] = useState(null);
    const [carInfo, setCarInfo] = useState(null);
    const [trains, setTrains] = useState([]);
    const trainsRef = React.useRef(trains);
    useEffect(() => {
        trainsRef.current = trains;
    }, [trains]);
    const [lastUpdate, setLastUpdate] = useState(null);
    const [timeRange, setTimeRange] = useState(2 * 60 * 60 * 1000);
    const filteredParams = Object.entries(PARAMETER_MAP).filter(([paramId, meta]) => {
        const text = `${paramId} ${meta.code} ${meta.name}`.toLowerCase();
        return text.includes(paramSearch.toLowerCase());
    });
    const [lastMessageTimestamp, setLastMessageTimestamp] = useState(null);
    const [telemetryAlert, setTelemetryAlert] = useState(null);
    const { temPermissao } = usePermissao();
    const podeVerTelemetria = temPermissao("Telemetria.Ver");


    // filtros
    const [activeFilter, setActiveFilter] = useState("Todos");
    const [filtroLinha, setFiltroLinha] = useLocalStorage('dashboard_filtroLinha');
    const [filtroStatus, setFiltroStatus] = useLocalStorage('dashboard_filtroStatus');

    const [errorModal, setErrorModal] = useState({
        show: false,
        message: ""
    });


    // históricos existentes
    const [trainHistory, setTrainHistory] = useState([]);
    const [carHistory, setCarHistory] = useState([]);
    const [rangeError, setRangeError] = useState(null);
    const [telemetryRaw, setTelemetryRaw] = useState([]);
    const displayRows = toDisplayTable(telemetryRaw);
    const uniqueDisplayRows = React.useMemo(() => {
        const seen = new Set();

        return displayRows.filter(row => {
            const key = `${row.id}-${row.timestamp}-${row.carro}-${row.code}`;

            if (seen.has(key)) return false;
            seen.add(key);
            return true;
        });
    }, [displayRows]);

    const [lastMsgId, setLastMsgId] = useState(0);

    //loading trem
    const [loadingTrain, setLoadingTrain] = useState(false);
    const [refreshingTrain, setRefreshingTrain] = useState(false);
    const [loadingChart, setLoadingChart] = useState(false);

    // gráficos adicionais
    const [additionalCharts, setAdditionalCharts] = useState([]);
    const MAX_ADDITIONAL_CHARTS = 3;
    const [chartTimeRanges, setChartTimeRanges] = useState({});
    const [loadingGraficosAdicionais, setloadingGraficosAdicionais] = useState(new Set());

    // categoria visual
    const getCategory = (status) => {
        const statusCard = (status || "Operacional").toString().toLowerCase();
        const isNormal = ["operacional", "em operação", "em operacao"].includes(statusCard);
        const isFalha = ["falha", "manutenção", "manutencao"].includes(statusCard);
        const isError = statusCard === "erro";
        const isDesligado = ["desligado", "parado"].includes(statusCard);

        if (isNormal) return "normal";
        if (isFalha) return "falha";
        if (isError) return "erro";
        if (isDesligado) return "desligado";
        return "normal";
    };

    const DEFAULT_RANGE = 2 * 60 * 60 * 1000;

    const getChartRange = (id) => {
        const range = chartTimeRanges[id];

        return typeof range === "number" && range > 0
            ? range
            : DEFAULT_RANGE;
    };

    const LINHAS_FIXAS = ["8", "9"];

    const linhasDisponiveis = React.useMemo(() => {
        const setLinhas = new Set(LINHAS_FIXAS);

        trains.forEach(t => {
            if (t.linhaNome) {
                setLinhas.add(t.linhaNome);
            }
        });

        return [...setLinhas].sort();
    }, [trains]);

    const statusDisponiveis = React.useMemo(
        () => [...new Set(trains.map(t => t.status).filter(Boolean))].sort(),
        [trains]
    );

    const filteredTrains = React.useMemo(
        () => trains.filter(t => {
            if (filtroLinha) {
                if (filtroLinha === 'semLinha') {
                    if (t.linhaNome) return false;
                } else if (t.linhaNome !== filtroLinha) {
                    return false;
                }
            }
            if (filtroStatus && t.status !== filtroStatus) return false;
            return true;
        }),
        [trains, filtroLinha, filtroStatus]
    );

    const isOperador = numeroLinhaOperador != null;

    // Operador: trava o filtro de linha na linha dele
    useEffect(() => {
        if (!isOperador || linhasDisponiveis.length === 0) return;
        const linhaOperador = linhasDisponiveis.find(l => String(l) === String(numeroLinhaOperador));
        if (linhaOperador != null) setFiltroLinha(linhaOperador);
    }, [isOperador, linhasDisponiveis.join(','), numeroLinhaOperador]);

    // Limpa filtros salvos que já não existem nas opções carregadas
    useEffect(() => {
        if (trains.length === 0) return;
        if (!isOperador && filtroLinha && filtroLinha !== 'semLinha' && !linhasDisponiveis.includes(filtroLinha)) {
            setFiltroLinha(null);
        }
        if (filtroStatus && !statusDisponiveis.includes(filtroStatus)) setFiltroStatus(null);
    }, [trains]);

    const [page, setPage] = useState(1);
    const [pageSize] = useState(100);
    const [totalPages, setTotalPages] = useState(1);
    const urlConfig = getConfig().API_URL;
    // carregar lista de trens
    useEffect(() => {
        if (!podeVerTelemetria) return;

        const fetchTrains = async () => {
            const [
                tremsFromTelemetry,
                dadosTrensResponse,
                linhasResponse
            ] = await Promise.all([
                api.telemetry.getAll(),
                api.trem.getAll(1, 100),
                api.linhas.getAll(),
            ]);

            const dadosTrens = dadosTrensResponse.data.items;

            const linhas = (linhasResponse?.data || []).map(l => ({
                id: l.id,
                nome: l.linha
            }));

            // quem tem telemetria "ativa" agora
            const idsComTelemetriaAtiva = new Set(
                tremsFromTelemetry.map(id => String(id))
            );

            const idsVisiveis =
                idLinhaOperador != null
                    ? new Set(
                        dadosTrens
                            .filter(t => t.linhaId === idLinhaOperador)
                            .map(t => String(t.identificadorTrem))
                    )
                    : null;

            setTrains(prev =>
                dadosTrens
                    .filter(
                        tremInfo =>
                            idsVisiveis == null ||
                            idsVisiveis.has(String(tremInfo.identificadorTrem))
                    )
                    .map(tremInfo => {
                        const tremId = tremInfo.identificadorTrem;

                        const linhaNomeRaw =
                            linhas.find(l => l.id === tremInfo?.linhaId)?.nome ?? null;

                        const linhaNome =
                            linhaNomeRaw != null ? String(linhaNomeRaw) : null;

                        const oldTrain = prev.find(
                            t => String(t.id) === String(tremId)
                        );

                        return {
                            ...oldTrain, // preserva alerts, speed e qualquer outro estado

                            id: tremId,

                            name: tremInfo.nomeCodigo ?? `T: ${tremId}`,

                            status: tremInfo.statusOperacao ?? "Desconhecido",

                            linhaNome,

                            segundosSemTelemetria: tremInfo?.segundosSemTelemetria,

                            ultimaTelemetria: tremInfo?.ultimaTelemetria,

                            tipoTrem: tremInfo?.tipoTrem,

                            telemetriaAtiva: idsComTelemetriaAtiva.has(String(tremId))
                        };
                    })
            );
        };

        fetchTrains();

        const interval =
            setInterval(fetchTrains, 10000);

        return () => clearInterval(interval);

    }, [
        podeVerTelemetria,
        idLinhaOperador
    ]);

    // Busca e mescla os alertas na lista de trens. Compartilhada entre o polling
    // periódico (abaixo) e o gatilho vindo do SSE de cada card (handleLiveUpdate).
    const alertsFetchingRef = React.useRef(false);

    const refreshAlerts = React.useCallback(async () => {

        if (!trainsRef.current.length) {
            return;
        }

        // Já tem uma chamada em andamento — pula esta (o polling de 5s e os
        // gatilhos dos cards podem colidir; sem isso viravam requisições
        // empilhadas em vez de uma de cada vez).
        if (alertsFetchingRef.current) {
            return;
        }

        alertsFetchingRef.current = true;

        try {

            const data = await api.telemetry.getAlerts();

            setTrains(prev =>
                prev.map(train => {

                    const trainAlerts = data.find(
                        a => String(a.trainId) === String(train.id)
                    );

                    return {
                        ...train,

                        alerts: trainAlerts?.alerts ?? {},

                        speed: trainAlerts?.speed ?? 0
                    };

                })
            );

        } catch (err) {

            console.error("Erro buscando alertas", err);

        } finally {

            alertsFetchingRef.current = false;

        }

    }, []);

    useEffect(() => {

        if (trainSelected !== null || carSelected !== null) {
            return;
        }

        // Se não há trens carregados ainda no momento em que o effect roda,
        // o polling continua de pé (não depende de trains.length) e só pula
        // a chamada até a lista existir — garante que o alerta apareça assim
        // que o card entra na tela, sem esperar o próximo ciclo de fetchTrains.
        //
        // Isso é o piso de segurança (mesmo intervalo de antes); cada card
        // também dispara refreshAlerts sozinho via handleLiveUpdate assim que
        // seu próprio SSE/polling individual (useTrainDashboardMonitor) recebe
        // um snapshot novo — normalmente bem mais rápido que esses 5s.
        refreshAlerts();

        const interval = setInterval(refreshAlerts, 5000);

        return () => clearInterval(interval);

    }, [trainSelected, carSelected, refreshAlerts]);

    // Gatilho dos cards: cada TrainCard assina o SSE por trem (o mesmo usado dentro
    // do trem, com fallback de polling se o SSE falhar) e chama isso quando recebe
    // um snapshot novo. Várias chamadas quase simultâneas (um lote mexe em vários
    // trens de uma vez) colapsam numa única requisição de alerts.
    const liveUpdateTimeoutRef = React.useRef(null);

    const handleLiveUpdate = React.useCallback(() => {

        if (liveUpdateTimeoutRef.current) {
            clearTimeout(liveUpdateTimeoutRef.current);
        }

        liveUpdateTimeoutRef.current = setTimeout(() => {
            refreshAlerts();
        }, 500);

    }, [refreshAlerts]);

    useEffect(() => {
        return () => {
            if (liveUpdateTimeoutRef.current) {
                clearTimeout(liveUpdateTimeoutRef.current);
            }
        };
    }, []);

    // atualizar trem
    useEffect(() => {

        if (!trainSelected) return;

        let cancelled = false;
        let timeout;

        const loop = async () => {

            if (cancelled) return;

            await fetchTrain(trainSelected, page, {
                silent: true
            });

            if (!cancelled)
                timeout = setTimeout(loop, 5000);

        };

        loop();

        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };

    }, [trainSelected, page]);


    // atualizar carro
    useEffect(() => {
        if (carSelected) {
            fetchCar(trainSelected, carSelected);
            const interval = setInterval(() => fetchCar(trainSelected, carSelected), 5000);
            return () => clearInterval(interval);
        }
    }, [carSelected, trainSelected]);

    useEffect(() => {
        if (!selectedParam || !trainSelected) {
            setLoadingChart(false);
            return;
        }

        setRangeError(null);

        const fetchRange = async (isInitialLoad = true) => {
            if (isInitialLoad) setLoadingChart(true);
            try {
                let url = `${urlConfig}/api/telemetry/trem/${trainSelected}/range?paramId=${selectedParam}&range=${timeRange}`;

                if (carSelected) {
                    url += `&carro=${carSelected}`;
                }

                const res = await fetch(url);
                if (!res.ok) {
                    try {
                        const errBody = await res.json();
                        console.error(`Erro HTTP ${res.status} /range:`, errBody);
                    } catch {
                        const errText = await res.text().catch(() => "");
                        console.error(`Erro HTTP ${res.status} /range:`, errText);
                    }
                    setTrainHistory([]);
                    setRangeError(`Erro ao buscar dados (HTTP ${res.status}).`);
                    if (isInitialLoad) setLoadingChart(false);
                    return;
                }

                const data = await res.json();
                const rows = Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []);

                const history = rows.map(d => ({
                    timestamp: Number(d.messageTimestamp),
                    value: Number(d.parameterValue)
                }));

                setRangeError(null);
                setTrainHistory(history);
            } catch (err) {
                console.error("Erro ao buscar telemetria por range", err);
                setTrainHistory([]);
                setRangeError("Erro de conexão ao buscar dados do gráfico.");
            } finally {
                if (isInitialLoad) setLoadingChart(false);
            }
        };

        fetchRange(true);

        const interval = setInterval(() => fetchRange(false), 5000);
        return () => clearInterval(interval);

    }, [selectedParam, trainSelected, timeRange]);

    // buscar dados dos gráficos adicionais
    const fetchSingleChart = async (chartId, paramId, range, isInitial = false) => {
        if (!paramId) return;

        if (isInitial) {
            setloadingGraficosAdicionais(prev => {
                const newSet = new Set(prev);
                newSet.add(chartId);
                return newSet;
            });
        }

        try {
            const json = await api.carro.getDadosGrafico(
                trainSelected,
                paramId,
                range
            );

            const rows = Array.isArray(json)
                ? json
                : (Array.isArray(json?.data) ? json.data : []);

            const history = rows.map(d => ({
                timestamp: Number(d.messageTimestamp),
                value: Number(d.parameterValue)
            }));

            setAdditionalCharts(prev =>
                prev.map(chart =>
                    chart.id === chartId
                        ? { ...chart, history }
                        : chart
                )
            );

        } catch (err) {
            console.error("Erro ao buscar gráfico adicional", err);
        } finally {
            if (isInitial) {
                setloadingGraficosAdicionais(prev => {
                    const newSet = new Set(prev);
                    newSet.delete(chartId);
                    return newSet;
                });
            }
        }
    };
    const chartsRef = React.useRef([]);
    const rangesRef = React.useRef({});
    useEffect(() => {
        chartsRef.current = additionalCharts;
    }, [additionalCharts]);

    useEffect(() => {
        if (!trainSelected) return;

        const interval = setInterval(() => {

            chartsRef.current.forEach(chart => {
                if (!chart.paramId) return;

                const range = rangesRef.current[chart.id];
                if (!range) return;

                fetchSingleChart(chart.id, chart.paramId, range);
            });

        }, 5000);

        return () => clearInterval(interval);

    }, [trainSelected]);

    const addChart = () => {
        if (additionalCharts.length >= MAX_ADDITIONAL_CHARTS) return;

        const newChartId = Date.now();
        setAdditionalCharts(prev => [
            ...prev,
            { id: newChartId, paramId: null, history: [] }
        ]);
        setChartTimeRanges(prev => ({
            ...prev,
            [newChartId]: 2 * 60 * 60 * 1000
        }));
    };

    const removeChart = (id) => {
        setAdditionalCharts(prev => prev.filter(chart => chart.id !== id));
        setChartTimeRanges(prev => {
            const newRanges = { ...prev };
            delete newRanges[id];
            return newRanges;
        });
    };

    const updateChartParam = (id, paramId) => {
        setAdditionalCharts(prev =>
            prev.map(chart =>
                chart.id === id ? { ...chart, paramId, history: [] } : chart
            )
        );

        const range = chartTimeRanges[id];
        if (!range) return;

        fetchSingleChart(id, paramId, range, true);
    };

    const updateChartTimeRange = (id, range) => {
        setChartTimeRanges(prev => ({
            ...prev,
            [id]: range
        }));

        const chart = additionalCharts.find(c => c.id === id);

        if (chart?.paramId) {
            fetchSingleChart(id, chart.paramId, range, true);
        }
    };

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeTick(Date.now());
        }, 10000); // a cada 10 segundos

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (!lastMessageTimestamp) return;

        const FIVE_MIN = 5 * 60 * 1000;
        const TEN_MIN = 10 * 60 * 1000;

        let timeoutId;

        const checkTelemetryDelay = () => {
            const now = Date.now();
            const diffMs = now - lastMessageTimestamp;

            if (diffMs >= TEN_MIN) {
                setTelemetryAlert("critical");
            } else if (diffMs >= FIVE_MIN) {
                setTelemetryAlert("warning");
            } else {
                setTelemetryAlert(null);
            }

            const nextCheckIn = Math.max(
                FIVE_MIN - diffMs,
                10000
            );

            timeoutId = setTimeout(checkTelemetryDelay, nextCheckIn);
        };

        checkTelemetryDelay();

        return () => clearTimeout(timeoutId);
    }, [lastMessageTimestamp]);

    useEffect(() => {
        rangesRef.current = chartTimeRanges;
    }, [chartTimeRanges]);
    if (!podeVerTelemetria) {
        return (
            <div style={styles.systemBackground}>


                <Box className="dashboard-page">
                    <Box component="main" className="dashboard-main">
                        <Paper elevation={0} className="dashboard-card">
                            <UserEmailDisplay />
                            {/* título */}
                            <Box className="dashboard-title-row">
                                <Typography variant="h5" className="dashboard-title">
                                    Painel de controle
                                    {numeroLinhaOperador != null && (
                                        <Typography component="span" variant="h5" className="dashboard-title-linha">
                                            {" "}· Linha {numeroLinhaOperador}
                                        </Typography>
                                    )}
                                </Typography>
                            </Box>

                            <SemPermissao />

                        </Paper>

                    </Box>

                </Box>



            </div>
        );
    }

    const fetchTrain = async (id, page = 1, { silent = false } = {}) => {
        try {
            if (!silent) {
                setLoadingTrain(true);
            } else {
                setRefreshingTrain(true);
            }

            const json = await api.carro.getDadosTrem(id, page, pageSize);

            //TODO
            //Alterar para quando tiver o ID do trem na telemetria
            const tremItem = json.data?.[0];
            const normalized = normalizeTelemetry(tremItem?.data ?? []);

            setTelemetryRaw(normalized);
            setTotalPages(json.totalPages);

            if (normalized.length > 0) {
                const latestTimestamp = Math.max(
                    ...normalized.map(m => Number(m.message_timestamp))
                );
                setLastMessageTimestamp(latestTimestamp);

                const d = new Date(latestTimestamp);
                setLastUpdate(
                    `${d.toLocaleTimeString("pt-BR")} • ${d.toLocaleDateString("pt-BR")}`
                );
            }

            setTrainInfo({
                ...parseTrainData(normalized),
                totalPassengers: tremItem?.totalPassengers ?? tremItem?.TotalPassengers
            });

            const carIds = [...new Set(normalized.map(msg => msg.carro))]
                .filter(id => id !== 0)
                .sort((a, b) => a - b);

            setCars(
                carIds.map(id => ({
                    id,
                    name: `Carro ${id}`,
                    status: "Operacional"
                }))
            );
        } catch (err) {
            console.error("Erro ao carregar telemetria:", err);

            setErrorModal({
                show: true,
                message: "Não foi possível carregar a telemetria. Tente novamente em alguns instantes."
            });
        }
        finally {
            setLoadingTrain(false);
            setRefreshingTrain(false);
        }
    };
    const GlobalOverlays = React.useMemo(() => (
        <>
            <Modal
                show={errorModal.show}
                type="error"
                message={errorModal.message}
                onClose={() =>
                    setErrorModal({ show: false, message: "" })
                }
            />
            {loadingTrain && <SimpleLoadingModal text="Carregando trem..." />}
        </>
    ), [errorModal, loadingTrain]);


    // dados do carro
    const fetchCar = async (trainId, carId) => {

        if (!trainId || !carId) {
            console.warn("fetchCar chamado sem trainId ou carId", trainId, carId);
            return;
        }
        const json = await api.carro.getTrem(trainId);
        const data = normalizeTelemetry(json.Mensagens || []);

        const carData = parseCarData(data, carId);

        if (!carData) {
            console.warn("Sem dados para o carro", carId);
            return;
        }

        setCarInfo(carData);

        setCarHistory(prev => [
            ...prev.slice(-49),
            {
                time: new Date().toLocaleTimeString(),
                temperature: carData.temperature ?? null,
                voltage: carData.voltage ?? null,
            }
        ]);

    };

    // ============================================================
    //  NÍVEL 3 → CARRO INDIVIDUAL
    // ============================================================
    const carAllowedParams = carSelected
        ? [
            ...new Set(
                telemetryRaw
                    .filter(m => m.carro === carSelected)
                    .map(m => Number(m.parameter_id))
            )
        ]
        : null;
    const currentTrain = trains.find(t => t.id === trainSelected);
    if (carSelected) {
        return (
            <CarView
                GlobalOverlays={GlobalOverlays}
                trainSelected={trainSelected}
                carSelected={carSelected}
                carInfo={carInfo}
                setCarSelected={setCarSelected}
                setTrainSelected={setTrainSelected}
                setTrainInfo={setTrainInfo}
                setCarInfo={setCarInfo}
                trains={trains}
                lastUpdate={lastUpdate}
                telemetryAlert={telemetryAlert}
                selectedParam={selectedParam}
                setSelectedParam={setSelectedParam}
                setTrainHistory={setTrainHistory}
                timeRange={timeRange}
                setTimeRange={setTimeRange}
                rangeError={rangeError}
                loadingTrain={loadingTrain}
                loadingChart={loadingChart}
                trainHistory={trainHistory}
                formatMetric={formatMetric}
                SmartChart={SmartChart}
                ParamAutocomplete={ParamAutocomplete}
                TimeRangeSelector={TimeRangeSelector}
                carAllowedParams={carAllowedParams}
                uniqueDisplayRows={uniqueDisplayRows}
            />
        );
    }

    // ============================================================
    //  NÍVEL 2 → TREM SELECIONADO
    // ============================================================
    if (trainSelected && trainInfo) {
        return (
            <TrainView
                GlobalOverlays={GlobalOverlays}
                trainSelected={trainSelected}
                trainInfo={trainInfo}
                trains={trains}
                cars={cars}
                setCarSelected={setCarSelected}
                fetchCar={fetchCar}
                setTrainSelected={setTrainSelected}
                setTrainInfo={setTrainInfo}
                setCarInfo={setCarInfo}
                selectedParam={selectedParam}
                setSelectedParam={setSelectedParam}
                trainHistory={trainHistory}
                setTrainHistory={setTrainHistory}
                timeRange={timeRange}
                setTimeRange={setTimeRange}
                loadingChart={loadingChart}
                additionalCharts={additionalCharts}
                chartTimeRanges={chartTimeRanges}
                loadingGraficosAdicionais={loadingGraficosAdicionais}
                updateChartParam={updateChartParam}
                updateChartTimeRange={updateChartTimeRange}
                removeChart={removeChart}
                addChart={addChart}
                MAX_ADDITIONAL_CHARTS={MAX_ADDITIONAL_CHARTS}
                uniqueDisplayRows={uniqueDisplayRows}
                lastUpdate={lastUpdate}
                telemetryAlert={telemetryAlert}
                PARAMETER_MAP={PARAMETER_MAP}
                MetricWidget={MetricWidget}
                SmartChart={SmartChart}
                ParamAutocomplete={ParamAutocomplete}
                TimeRangeSelector={TimeRangeSelector}
                Gauge={Gauge}
                GaugeContainer={GaugeContainer}
                GaugeReferenceArc={GaugeReferenceArc}
                GaugeValueArc={GaugeValueArc}
                Velocimetro={Velocimetro}
                CarCard={CarCard}
            />
        );
    }

    // ============================================================
    //  NÍVEL 1 → LISTA DE TRENS
    // ============================================================
    return (
        <>
            {GlobalOverlays}

            <Box className="dashboard-page">
                <Box component="main" className="dashboard-main">
                    <Paper elevation={0} className="dashboard-card">
                        <UserEmailDisplay />
                        {/* título */}
                        <Box className="dashboard-title-row">
                            <Typography variant="h5" className="dashboard-title">
                                Painel de controle
                                {numeroLinhaOperador != null && (
                                    <Typography component="span" variant="h5" className="dashboard-title-linha">
                                        {" "}· Linha {numeroLinhaOperador}
                                    </Typography>
                                )}
                            </Typography>
                        </Box>

                        {/* legenda */}
                        <LegendClass />

                        {/* filtros */}
                        <FiltrosTrens
                            linhas={
                                linhasDisponiveis.map((l) =>
                                ({
                                    value: l,
                                    label: `Linha ${l}`
                                }))}
                            statusList={
                                statusDisponiveis.map((s) =>
                                ({
                                    value: s,
                                    label: s
                                }))}
                            filtroLinha={filtroLinha}
                            setFiltroLinha={setFiltroLinha}
                            filtroStatus={filtroStatus}
                            setFiltroStatus={setFiltroStatus}
                            mostrarSemOpcoes={!isOperador}
                            linhaDesabilitada={isOperador}
                        />

                        {/* lista de trens */}
                        <Box className="dashboard-content">
                            <TrainListClass
                                trains={filteredTrains}
                                setTrainSelected={setTrainSelected}
                                setLoadingTrain={setLoadingTrain}
                                onLiveUpdate={handleLiveUpdate}
                            />
                        </Box>

                    </Paper>

                </Box>

            </Box>
        </>
    );

}

export default TrainDashboard;
